import { createDomainToken, createServiceToken } from "./tokens.js";
//#region src/sdk/contracts.ts
var SDK_DOMAINS = {
	BLOG: createDomainToken("sdk.domain.blog"),
	PAGES: createDomainToken("sdk.domain.pages"),
	SITE_SETTINGS: createDomainToken("sdk.domain.site-settings"),
	CACHE_REVALIDATION: createDomainToken("sdk.domain.cache-revalidation"),
	CONTACT_SUBMISSIONS: createDomainToken("sdk.domain.contact-submissions")
};
var SDK_SERVICES = { COMPONENT_PROPS_MAPPER_REGISTRY: createServiceToken("sdk.service.component-props-mapper-registry") };
//#endregion
export { SDK_DOMAINS, SDK_SERVICES };

//# sourceMappingURL=contracts.js.map